import authApi from '../../../services/authApi';
import logger from '../../../utils/logger';

export const cadastroService = {

    async verificarDocumento(documento) {

        try {

            const response = await authApi.get(
                `/cadastro/verificar/documento/${documento}`
            );

            return response.data;

        } catch (error) {

            logger.error('Erro ao verificar documento', error);

            throw error;
        }
    },

    async cadastroCompleto(dados) {

        try {

            const response = await authApi.post(
                '/cadastro/completo',
                dados
            );

            return response.data;

        } catch (error) {

            logger.error('Erro ao cadastrar usuário', error);

            throw error;
        }
    }

};